import { useState } from "react";
import seventyEightImage from "../../assets/78-needle-and-soundbox.jpg";
import casetteImage from "../../assets/DN-780R.jpg";
import lpImage from "../../assets/website needle.jpeg";
import reelToReelImage from "../../assets/akai.jpg";
import "./Services.css";

const TAB_STATE = Object.freeze({
    SEVENTY_EIGHT: "78s",
    CASETTE: "Casettes",
    LP: "LPs",
    REEL: "Reel-to-reels",
});

export const Services = () => {
    const [tab, setTab] = useState(TAB_STATE.SEVENTY_EIGHT);

    return (
        <div className="services-container">
            <h1>Services</h1>
            <div className="buttons-container">
                <button
                    className={`tab-button ${
                        tab === TAB_STATE.SEVENTY_EIGHT && "active"
                    }`}
                    onClick={() => setTab(TAB_STATE.SEVENTY_EIGHT)}
                >
                    78s
                </button>
                <button
                    className={`tab-button ${
                        tab === TAB_STATE.CASETTE && "active"
                    }`}
                    onClick={() => setTab(TAB_STATE.CASETTE)}
                >
                    Casettes
                </button>
                <button
                    className={`tab-button ${tab === TAB_STATE.LP && "active"}`}
                    onClick={() => setTab(TAB_STATE.LP)}
                >
                    LPs
                </button>
                <button
                    className={`tab-button ${
                        tab === TAB_STATE.REEL && "active"
                    }`}
                    onClick={() => setTab(TAB_STATE.REEL)}
                >
                    Reel-to-reel
                </button>
            </div>
            <div>
                <p className={tab !== TAB_STATE.SEVENTY_EIGHT && "hidden"}>
                    <img className="service-image" src={seventyEightImage} />
                    Transfer of 78 to CD & MP3
                    <br />
                    Basic pricing £10.00 per disc (both sides)
                    <br />
                    <br />
                    If you think you have a 78 record, the most obvious clue is
                    that on the label - if it's survived - will be '78 rpm',
                    almost always with commercially produced records.
                    <br />
                    <br />
                    However, personal recordings were often made in 'recording
                    booths' where the music/speech was cut directly into the
                    record and, in my experience, the helpful '78' bit is often
                    missing.
                    <br />
                    <br />
                    There are several sizes, 7", 10" & 12" and all at more or
                    less 78 rpm, although this did vary. Commercial 78s are
                    normally made from shellac, an early plastic, and are quite
                    heavy and brittle. The recording booth versions were made
                    from thin metal coated in black plastic and are much lighter
                    and the edges are shiny where the metal can be seen.
                    <br />
                    <br />
                    Every transfer includes deep (wet) clean/click & pop
                    removal/CD case/cover with text & on-CD printing. All tracks
                    split as you would find on the original version.
                </p>
                <p className={tab !== TAB_STATE.CASETTE && "hidden"}>
                    <img className="service-image" src={casetteImage} />
                    Transfer of cassette tapes to CD or MP3
                    <br />
                    Basic Pricing £19.50 per cassette - up to 80 minutes.
                    <br />
                    <br />
                    If you were ever in a band then the likelihood is that
                    you’ve got a demo tape or tapes. The vast majority of demo
                    recordings were done on standard audio cassette. Recordings
                    of your children playing piano or a grandparent's
                    reminiscences will also normally have been recorded onto
                    audio cassette. Audio cassettes come in a variety of types
                    and lengths C-30/C-60/C-90 (30/60/90 minutes respectively),
                    standard, Chrome (CrO2) or metal. We can also transfer both
                    Mini & Micro cassettes from dictaphones or old answering
                    machines. Although normally between 15 & 30 minutes long
                    these are quoted on an individual basis as they can be very
                    noisy.
                    <br />
                    <br />
                    Basic pricing is £19.50 per cassette up to 80 minutes in
                    length.
                    <br />
                    <br />
                    A 30 minute standard cassette is £14.00 if it's 10 minutes
                    or less.
                    <br />
                    <br />
                    A micro or mini cassette is £19.50 unless it's very short.
                    <br />
                    <br />
                    Includes de-hiss/track splitting/CD case/cover with text and
                    ON-CD printing. All tracks split as you would find on the
                    original version. I can also repair broken or damaged tapes
                    and then recover most (if not all) of the audio.
                </p>
                <p className={tab !== TAB_STATE.LP && "hidden"}>
                    <img className="service-image" src={lpImage} />
                    Transfer of LP to CD & MP3
                    <br />
                    Basic Pricing of £20.00 for both sides
                    <br />
                    <br />
                    The transfer of an LP or single (45 rpm) to CD is usually
                    much more predictable than that of a 78. In most cases you
                    would never know that the CD copy had ever come from an LP.
                    This does, of course, depend on the condition of the
                    original.
                    <br />
                    <br />
                    Due to copyright law, we can only produce one copy of a
                    commercial LP (unless it's 50+ years old). Please note it is
                    illegal to reproduce the cover of an LP (scan & print),
                    unless you own the copyright or have written permission. So
                    each transfer has a simple text on white cover, unless you
                    have something specific in mind (for example a photo or your
                    own artwork).
                    <br />
                    <br />
                    Basic pricing is £20.00 per LP (both sides). Singles £6.00
                    per single (both sides).
                    <br />
                    <br />
                    Every transfer includes deep (wet) clean / click & pop
                    removal / CD case / cover with text & ON-CD printing. All
                    tracks split as you would find on the original version.
                </p>
                <p className={tab !== TAB_STATE.REEL && "hidden"}>
                    <img className="service-image" src={reelToReelImage} />
                    Transfer of Reel to Reel to CD & MP3
                    <br />
                    Basic pricing of £26 per hour of material
                    <br />
                    <br />
                    Domestic and Studio Reel to Reel tapes come in a variety of
                    sizes 3” to 10.5” and were recorded at several speeds, 1 7/8
                    ips(inches per second) to 15 ips, either in mono or stereo.
                    <br />
                    <br />
                    Taking all this into account the ways in which something was
                    recorded can be many and varied. It is also possible that a
                    single tape can have audio on it that was recorded at
                    different speeds. At Audio Reunited we have Reel to Reel
                    machines that can handle all the sizes and speeds mentioned
                    and if it’s at a different speed we can employ computer
                    software to speed up or slow the recording as appropriate.
                    Reel to Reel tape transfers are priced on the length of the
                    recording.
                    <br />
                    <br />
                    Basic pricing is £26.00 per hour of material plus editing
                    (if required)
                    <br />
                    <br />
                    Includes track splitting / CD case / cover with text & On-CD
                    printing
                </p>
            </div>
        </div>
    );
};
